
import "./portofolio.scss"



export default function Portofolio() {
 
  return (
    <div className="portfolio" id="portfolio">
      <h1>Portfolio</h1>
      <div className="container">
      <div className="item">
          <img src="assets/web.png" alt="" />
          <h3>Web layout</h3>
        </div>

        <div className="item">
          <img src="assets/web.png" alt="" />
          <h3>Web layout</h3>
        </div>

        <div className="item">
          <img src="assets/web.png" alt="" />
          <h3>Web layout</h3>
        </div>
        <div className="item">
          <img src="assets/web.png" alt="" />
          <h3>Web layout</h3>
        </div>
    
     
       


      </div>
    </div>
  )
}
